// extracted by mini-css-extract-plugin
export var columnList = "_fm-0";